import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { CalendarPicker } from "@mui/x-date-pickers";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { TextField } from "@mui/material";

const minCalendarWidth = 250;
const minCalendarHeight = 170;

function DurationCalendar(props) {
  //const [locale, setLocale] = useState("nl");
  //const [selectedDate, handleDateChange] = useState(new Date());
  const { i18n } = useTranslation();

  return (
    <LocalizationProvider
      adapterLocale={moment.locale(i18n.language)}
      dateAdapter={AdapterMoment}
    >
      <StaticDatePicker
          displayStaticWrapperAs="desktop"

        minDate={moment(props.minDate)}
        value={props.selectedDate}
        onChange={props.handleDateChange}
        onError={console.log}
        //disablePast
        //format="DD/MM/YYYY HH:mm"
        onClose={() => props.handleClose()}
        openTo="day"
        views={["month", "day"]}
        renderInput={(params) => <TextField {...params} variant="standard" />}
      />
    </LocalizationProvider>
  );
  /* <React.Fragment>
      <MuiThemeProvider theme={customTheme}>
        <MuiPickersUtilsProvider
          libInstance={moment}
          utils={MomentUtils}
          locale={moment.locale(i18n.language)}
        >
          <DatePicker
            variant="static"
            disableToolbar
            minDate={moment(props.minDate).toDate()}
            //open={isOpen}
            // onOpen={() => setIsOpen(true)}
            // onClose={() => setIsOpen(false)}
            ampm={false}
            value={props.selectedDate}
            onChange={props.handleDateChange}
            onError={console.log}
            //disablePast
            format="DD/MM/YYYY HH:mm"
            onClose={() => props.handleClose()}
            autoOk={true}
          />
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    </React.Fragment> */
}

export default DurationCalendar;
